import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { FleetHealth } from '@/lib/types';

/**
 * Whether the data is actually arriving, as opposed to what the fleet list says
 * exists. Every fact here used to require an SSH session and four queries.
 */

export function useFleetHealth(days = 7) {
  return useQuery({
    queryKey: ['fleet-health', days],
    queryFn: () => apiFetch<FleetHealth>(`/v1/admin/fleet-health?days=${days}`),
    // Freshness is the point of the screen, so it goes stale quickly.
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
  });
}

export function useClaimDevice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ident: string) =>
      apiFetch<{ id: string; name: string }>('/v1/admin/fleet-health/claim', {
        method: 'POST',
        body: JSON.stringify({ ident }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fleet-health'] }),
  });
}
